<template>
  <p class="details">
    <strong>Share via Email:</strong>
    <span class="ml-1 text-brandPrimary">Non-active JobNav users</span>
    will be sent an invitation to join JobNav in order to access the report.
  </p>
</template>

<style scoped lang="less">
.details {
  font-size: 12px;
  line-height: 150%;
  font-weight: 500;
}
</style>
